import { useIntl } from 'react-intl';
import { formatCurrency, formatDateHour } from 'utils';

import { TableColumn } from '../..';

import { PaymentExtrasTableProps } from './types';

import * as S from '../styles';

const PaymentExtrasTable: React.FC<PaymentExtrasTableProps> = ({
  data = [],
  isLoading,
  extrasTotal,
  currencyCode,
  isClosedInvoice,
}) => {
  const intl = useIntl();

  const extraData = [
    ...data,
    {
      name: 'CPPAYMENTS.TEXT.SUBTOTAL',
      finalValue: extrasTotal,
    },
  ];

  const columns: TableColumn[] = [
    {
      key: 'transaction_name',
      dataKey: 'name',
      title: intl.formatMessage({ id: 'CPPAYMENTS.COLUMNTITLE.TYPE' }),
      render: (name: string) => {
        if (name === 'CPPAYMENTS.TEXT.SUBTOTAL')
          return intl.formatMessage({ id: 'CPPAYMENTS.TEXT.SUBTOTAL' });

        return intl.formatMessage({ id: `PAYMENTS.CP.COLUMN.${name}` });
      },
    },
    {
      key: 'transaction_description',
      dataKey: 'description',
      title: intl.formatMessage({ id: 'CPPAYMENTS.COLUMNTITLE.DESCRIPTION' }),
    },
    {
      key: 'transaction_date',
      dataKey: 'date',
      title: intl.formatMessage({ id: 'CPPAYMENTS.COLUMNTITLE.DAYANDHOUR' }),
      render: (date: string) =>
        date ? formatDateHour(date, { locale: intl.locale }) : '',
    },
    {
      key: 'transaction_final_value',
      dataKey: 'finalValue',
      title: intl.formatMessage({ id: 'CPPAYMENTS.COLUMNTITLE.VALUE' }),
      render: (finalValue: number | null) =>
        typeof finalValue === 'number'
          ? formatCurrency(finalValue, currencyCode)
          : '-',
    },
  ];

  return (
    <S.Container data-testid="invoice-extras-table-container">
      <S.StyledTable
        columns={columns}
        data={extraData}
        loadingLines={4}
        loading={isLoading}
        loadingStyle="LinesMedium"
        isClosedInvoice={isClosedInvoice}
      />
    </S.Container>
  );
};

export default PaymentExtrasTable;
